/**
 * Frontend Entry Point
 *
 * This is the main entry point for the React application.
 * It renders the App component to the DOM and initializes Google Analytics.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import App from './App';
import config from './config';
import './index.css';

// Initialize Google Analytics if measurement ID is available
if (config.gaMeasurementId && config.gaMeasurementId !== 'G-XXXXXXXXXX') {
  ReactGA.initialize(config.gaMeasurementId);
  console.log('Google Analytics initialized with ID:', config.gaMeasurementId);

  // Send initial pageview
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
} else {
  console.warn('Google Analytics not initialized: Missing or invalid Measurement ID');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
